module.exports = __webpack_public_path__ + "img/201908-3.63bbd978.png";